export default {
  activeStoreIndex: 0
}
